import { render } from "./FundList.vue?vue&type=template&id=2acb7d6f&scoped=true"
import script from "./FundList.vue?vue&type=script&lang=js"
export * from "./FundList.vue?vue&type=script&lang=js"

import "./FundList.vue?vue&type=style&index=0&id=2acb7d6f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acb7d6f"]])

export default __exports__